export interface KeywordDomainRankGq {
  domainId: number;
  rank: number;
  url: string;
  featuredSnippet: boolean;
}

export const KeywordDomainRankGqProps = `
  domainId
  rank
  url
  featuredSnippet
`;
